import * as Colors from '../constants/Colors';
import { InlineText } from '../typography/InlineText';
import { FC, PropsWithChildren } from 'react';
import { FlexBox } from '../layout';
import { FontSizeProps, PaddingProps } from 'styled-system';

export type TagProps = FontSizeProps &
    PaddingProps & {
        color?: string;
        backgroundColor?: string;
    };

export const Tag: FC<React.PropsWithChildren<PropsWithChildren<TagProps>>> = ({
    children,
    backgroundColor,
    color,
    fontSize,
    padding,
    ...args
}) => {
    return (
        <FlexBox
            data-testid="Tag-Container"
            display="inline-flex"
            alignItems="center"
            backgroundColor={backgroundColor}
            color={color}
            padding={padding}
            borderRadius="6px"
            {...args}
        >
            <InlineText fontSize={fontSize} fontWeight="600">
                {children}
            </InlineText>
        </FlexBox>
    );
};

Tag.defaultProps = {
    backgroundColor: Colors.hsBlue,
    color: Colors.white,
    fontSize: '12px',
    padding: '4px 8px',
};
